export const isDevelopment =
  process.env.NODE_ENV === "development" ||
  process.env.NEXT_PUBLIC_VERCEL_ENV === "development" ||
  process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";
export const isStaging = process.env.VERCEL_GIT_COMMIT_REF === "staging";
export const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === "production";

export const isPreview =
  process.env.VERCEL_ENV === "preview" ||
  process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";

export const referer = isProduction
  ? "https://zapier.com"
  : "https://zapier-staging.com";

export const baseUrl =
  process.env.NEXT_PUBLIC_ZAPIER_ORIGIN || process.env.BASE_URL;

// Feature flag for support development chips (Force Chat, etc.)
export const isSupportDevChipsEnabled = isProduction
  ? false
  : process.env.NEXT_PUBLIC_ENABLE_SUPPORT_DEV_CHIPS === "true" ||
    process.env.NEXT_PUBLIC_ENABLE_SUPPORT_DEV_CHIPS === "on";
